export const stripHtml = (html: string) => {
  const tmp =
    typeof document !== "undefined"
      ? document.createElement("div")
      : { innerHTML: "", innerText: "", textContent: "" };
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText;
};
